import React, { Component } from 'react'
import {
  MDBContainer,
  MDBBtn,
  MDBIcon,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
} from 'mdb-react-ui-kit'
import MDB4Datatable from '../components/content/MDB4Datatable/MDB4Datatable.component'
import DashboardLayout from '../components/Admin/DashboardLayout'
import AdminApi from '../api/admin-api/admin-api'
import { withRouter } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import moment from 'moment'

class AdminDashboardContentPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      confirmModal: false,
      viewdata: '',
      pageList: [],
      pagination: { page: 0, per_page: 10 },
      data: {
        columns: [
          {
            label: 'Page Name',
            field: 'name',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Created At',
            field: 'createdAt',
            sort: 'asc',
            width: 150,
          },
          {
            label: 'Actions',
            field: 'actions',
            sort: 'disabled',
            width: 150,
          },
        ],
        rows: [],
      },
    }
  }

  componentDidMount() {
    this.fetchContentData()
  }

  handleResize = () =>
    this.setState({
      windowWidth: window.innerWidth,
    })

  fetchContentData = async () => {
    this.setState({ loading: true })

    try {
      const result = await AdminApi.getContentRequest()
      const pages = result.data.data || []

      this.setState({ pageList: pages, loading: false }, () => {
        this.setRows()
      })
    } catch (error) {
      this.setState({ loading: false })
      toast.error('Something went wrong!', {
        position: toast.POSITION.TOP_RIGHT,
      })
    }
  }

  setRows = () => {
    const { pageList } = this.state
    if (pageList && pageList.length) {
      let rows = pageList.map(row => {
        const { page_name, created_at, id } = row
        const submittedDate = (
          <span data-searchvalue={created_at ? moment(created_at).format('YYYY/MM/DD') : ''}>
            {created_at ? moment(created_at).format('MM/DD/YYYY') : 'N/A'}
          </span>
        )
        const self = this

        function edit() {
          self.props.history.push(`/content-pages/${id}/edit`)
        }

        function deletePage() {
          self.confirmDeletePage({ viewdata: row })
        }

        const actions = (
          <div className={'d-flex align-items-center justify-content-center'}>
            {/*<MDBBtn type="button" color="default" rounded size="sm" onClick={view}>
                        View
                    </MDBBtn>*/}
            <div className={'cursor-pointer d-inline-block me-3'} role={'button'} onClick={edit}>
              <i className={'fa fa-edit fa-2x blue-text p-1'}></i>
            </div>
            <div className={'cursor-pointer d-inline-block'} onClick={deletePage}>
              <i className={'fa fa-trash fa-2x red-text p-1'}></i>
            </div>
          </div>
        )
        return {
          name: `${page_name}`,
          createdAt: submittedDate,
          actions: actions,
        }
      })
      this.setState({
        data: { ...this.state.data, rows: rows },
      })
    }
  }

  confirmToggle = (data = {}) => {
    this.setState({ confirmModal: !this.state.confirmModal, ...data })
  }

  onChange = event => {
    this.setState({ [event.target.name]: event.target.value })
  }

  confirmDeletePage = data => {
    this.confirmToggle(data)
  }

  deletePage = async id => {
    this.setState({ deleting: true })
    try {
      await AdminApi.deletePage({ type: 'agency_content', id }).then(response => {
        this.setState({ deleting: false })
        if (response.status === 200) {
          this.confirmToggle()
          toast.success('Page successfully deleted', {
            position: toast.POSITION.TOP_RIGHT,
          })
          this.fetchContentData()
        }
      })
    } catch (e) {
      this.setState({ deleting: false })
      this.confirmToggle()
      let error = e.message
      toast.error(`${error}`, { position: toast.POSITION.TOP_RIGHT })
    }
  }

  render() {
    toast.configure()
    const { confirmModal, data, loading } = this.state

    const createNew = () => {
      this.props.history.push('/content-pages/new')
    }

    return (
      <>
        <DashboardLayout>
          <main className='mainSection'>
            <MDBContainer fluid className='mt-5'>
              <h2>
                Pages
                <div className='d-inline-block'>
                  <MDBBtn type='button' color='default' tag='a' floating gradient='blue' onClick={createNew}>
                    <MDBIcon icon='plus' />
                  </MDBBtn>
                </div>
              </h2>
              {loading ? (
                <h4 className={'p4'}>Loading...</h4>
              ) : (
                <>
                  <MDB4Datatable
                    data={data}
                    sortRows={['name', 'createdAt']}
                    striped
                    bordered
                    small
                    order={['name', 'asc']}
                    entriesOptions={[100, 150, 200]}
                    entries={100}
                    className='text-capitalize'
                  />
                </>
              )}

              <MDBModal open={confirmModal} tabIndex='-1' onClose={this.confirmToggle}>
                <MDBModalDialog size='sm'>
                  <MDBModalContent>
                    <MDBModalHeader>
                      <MDBModalTitle>Delete Page</MDBModalTitle>
                      <MDBBtn type='button' className='btn-close' color='none' onClick={this.confirmToggle}></MDBBtn>
                    </MDBModalHeader>
                    <MDBModalBody>
                      <div className='h5'>Are you sure you want to delete this page?</div>
                      <MDBBtn type='button' color='secondary' size={'sm'} onClick={this.confirmToggle}>
                        Close
                      </MDBBtn>
                      <MDBBtn
                        type='button'
                        color='danger'
                        size={'sm'}
                        onClick={() => {
                          this.deletePage(this.state.viewdata.id)
                        }}
                      >
                        {this.state.deleting ? 'Deleting...' : 'Delete'}
                      </MDBBtn>
                    </MDBModalBody>
                  </MDBModalContent>
                </MDBModalDialog>
              </MDBModal>
            </MDBContainer>
          </main>
        </DashboardLayout>
      </>
    )
  }
}

export default withRouter(AdminDashboardContentPage)
